import type { AppExportConnector } from '@appStore/reducers/app'
import { setBrokerDependencies } from './appImportBroker.js'

export interface InitBrokerAppDeps {
	connectorAPI: { getSnailyProfile: () => Promise<unknown> }
	connector: unknown
	appExportConnector: AppExportConnector | null
	CONSTS: { EXTENSION_ID: string; API: { URL_AUTOMATION: string } }
	httpRequest: (config: {
		method: string
		url: string
		data?: unknown
	}) => Promise<{ data?: unknown } | undefined>
}

export function initImportRunnerBroker(appDeps: InitBrokerAppDeps): void {
	const { connectorAPI, CONSTS, httpRequest } = appDeps
	const automationV1Base =
		CONSTS.API.URL_AUTOMATION.replace(/v2\/?$/, '') + 'v1/'

	setBrokerDependencies({
		automationApiV1Request: async (
			method: string,
			path: string,
			body: unknown
		) => {
			const result = (
				await httpRequest({
					method,
					url: automationV1Base + path,
					data: body
				})
			)?.data
			return result
		},
		automationApiV2Request: async (
			method: string,
			path: string,
			body: unknown
		) => {
			const result = (
				await httpRequest({
					method,
					url: CONSTS.API.URL_AUTOMATION + path,
					data: body
				})
			)?.data
			return result
		},
		getAppBaseUrl: () => {
			const result = typeof window !== 'undefined' ? window.location.origin : ''
			return result
		},
		getSnailyProfile: async () => {
			const result = connectorAPI.getSnailyProfile()
			return result
		},
		onExportEvent: (event: unknown) => {
			const result =
				typeof document !== 'undefined' &&
				document.dispatchEvent(
					new CustomEvent('SnailyEvent', { detail: event })
				)
			return result
		}
	})
}
